export default {"src":"/_next/static/media/print-annsacks.82c27adc.svg","height":17,"width":17};